import { ColoursObj } from '@eventr/common-storybook'
import { Box } from '@mui/material'
interface ITextOverlayProps {
    children: React.ReactNode
}
export const TextOverlay = ({ children }: ITextOverlayProps) => {
    return (
        <Box
            sx={{
                position: 'relative',
                zIndex: 1,
                width: 'fit-content',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: '-4px',
                    right: '-4px',
                    bottom: 0,
                    backgroundColor:
                        reverseHexColour(ColoursObj.font.primary) + '40',
                    zIndex: -1,
                    borderRadius: '4px',
                }}
            />
            {children}
        </Box>
    )
}

export const reverseHexColour = (colour: string) => {
    const hex = colour.replace('#', '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    return `#${(
        (1 << 24) +
        (255 - r) * (1 << 16) +
        (255 - g) * (1 << 8) +
        (255 - b)
    )
        .toString(16)
        .slice(1)}`
}
